<template>
  <div class="wl-container">
    <!-- <div class="button-content" :style="{visibility: !isKpmgUser ? 'visiable' : 'hidden'}"> -->
    <div class="button-content" v-if="!isKpmgUser">
      <el-button icon="el-icon-star-off" class="wl-green" @click="goToMyCourse">{{ $t('kee_my') }}</el-button>
    </div>
    <el-carousel trigger="click" class="course-carousel">
      <el-carousel-item v-for="item in homeRotateList" :key="item.courseId">
        <img @click="goDetail(item)" :src="'data:image/png;base64,'+ item.imageByte" class="imageItem" alt=""/>
      </el-carousel-item>
    </el-carousel>
    <div class="wl-client-container kpmg">
      <template v-for="(item, index) in menu">
        <div class="wl-client-item" :class="'item' + (index + 1)">
          <div class="iconNew" v-if="newTag[item.newTag]"></div>
          <div class="menu_item_info"  @click="clickCourseList(item)">
            <img :src="item.src" />
            <div :style="'color: '+ getFontColor(index)" :class="[$i18n.locale === 'en' ? 'en-fontSize' : '']">
              {{ $t(item.name) }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
  import API from '@/api'
  import {mapGetters} from "vuex";
  export default {
    name: "courseContent",
    components: {},
    data() {
      return {
        colorList: ['#00338d','#00b8f5','#3879EB','#fd349c','#7213ea'],
        menu: [
          {name: "kee_menu_1", src: require("@/assets/img/Insights-icon – 1.png"), tag: "ACCOUNTING_COURSE",newTag: "accountingCourseNewFlag"},
          {name: "kee_menu_2", src: require("@/assets/img/Insights-icon – 2.png"), tag: "TAX_COURSES",newTag: "taxCoursesNewFlag"},
          {name: "kee_menu_3", src: require("@/assets/img/Insights-icon – 3.png"),tag: "DEVELOPMENT_COURSES",newTag: "developmentCoursesNewFlag"},
          {name: "kee_menu_4", src: require("@/assets/img/Insights-icon – 4.png"), tag: "AUDIT_COOPERATION",newTag: "auditCooperationNewFlag"},
          // {name: "kee_menu_5", src: require("@/assets/img/Insights-icon – 5.png")},
        ],
        homeRotateList: [],
        newTag: {}
      }
    },
    computed: {
      ...mapGetters('common', {
        getUser: 'getUser',
      }),
      isKpmgUser() {
        return this.getUser.userType === '1'
      }
    },
    mounted() {
      this.getHomeRotate()
      this.getTagStatus()
      this.repairRotateHeight()
    },
    methods: {
      repairRotateHeight() {
        const _interval = setInterval(() => {
          try {
            if (this.homeRotateList.length > 0) {
              document.getElementsByClassName('course-carousel')[0].style.height = document.getElementsByClassName('imageItem')[0].offsetHeight + 'px'
              clearInterval(_interval)
            } else {
              document.getElementsByClassName('course-carousel')[0].style.height = '83%'
            }
          } catch (e) {
             
            clearInterval(_interval)
          }
        }, 500)
      },
      getFontColor(index) {
        return this.colorList[index]
      },
      getHomeRotate() {
        API.insights.queryHomeRotate().then(res => {
          if (res.code === '1') {
            this.homeRotateList = res.data
          } else {
            this.$message.error(this.$t(res.code));
          }
        })
      },
      getTagStatus() {
        API.insights.queryTagStatus().then(res => {
          if (res.code === '1') {
            this.newTag = res.data
          } else {
            this.$message.error(this.$t(res.code));
          }
        })
      },
      clickCourseList(item) {
        if(item.tag) {
          this.$router.push({name: "courseList", query: { kccTag: item.tag }})
        }else {
          this.$router.push({name: "csConsult"})
        }
      },
      goDetail(item) {
        if(item.courseId) {
          this.$router.push({name: "courseDetail", query: { courseId: item.courseId }})
        }
      },
      goToMyCourse() {
        this.$router.push({name: "myCourse"})
      },
    }
  }
</script>
<style scoped>
  .wl-container {
    color: #444;
    height: 100%;
    background: #eff1f5;
    padding: 15px;
  }

  .button-content {
    margin-bottom: 15PX;
    text-align: right;
  }

   .course-carousel {
    /* max-height: 100%; */
    /* min-height: 83%; */
    width: 100%;
    overflow: hidden;
    height: calc(100% - 220px);
  }
  ::v-deep .el-carousel__container {
    height: 100%;
  }

  /* ::v-deep .el-carousel__container .el-carousel__arrow {
    top: 30vh;
  } */

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
  .el-carousel__item {
    height: fit-content;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
    width: 100%;
  }
  .wl-client-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 20px;
  }
  .wl-client-item {
    position: relative;
    background: #fff;
    width: calc((100% - 60px) / 4 );
    height: 180px;
    margin-right: 20px;
    /*margin-bottom: 20px;*/
    text-align: center;
    cursor: pointer;
    font-size: 32px;
    line-height: 40px;
    border-radius: 10px;
  }

  .wl-client-item:nth-child(4n){
    margin-right: 0;
  }
  .iconNew {
    display: inline-block;
    position: absolute;
    background: url("~@/assets/img/icon-new.svg") center center/100% 100% no-repeat;
    width: 60px;
    height: 60px;
    left: -10px;
    top: -25px;
  }
  .en-fontSize {
    font-family: 'Open Sans Condensed',Arial,Helvetica,sans-serif;
}
  /* .wl-client-item::before {
    content: '';
    display: block;
    height: 28PX;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  } */
  /* .wl-client-item.item1:before {
    background: url("~@/assets/img/bg-Client-01.png") center center/100% 100% no-repeat;
  }
  .wl-client-item.item2:before {
    background: url("~@/assets/img/bg-Client-04.png") center center/100% 100% no-repeat;
  }

  .wl-client-item.item3:before {
    background: url("~@/assets/img/bg-Client-06.png") center center/100% 100% no-repeat;
  }

  .wl-client-item.item4:before {
    background: url("~@/assets/img/bg-Client-03.png") center center/100% 100% no-repeat;
  }

  .wl-client-item.item5:before {
    background: url("~@/assets/img/bg-Client-02.png") center center/100% 100% no-repeat;
  } */

  .menu_item_info{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* margin-top: 28px; */
    height: calc(100%);
    padding: 20px;
    /* border: 1PX solid #cfcfcf; */
    /* border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px; */
  }
  .menu_item_info img{
    height: 50px;
    margin-bottom: 20px;
  }
  .imageItem {
    display: block;
    width: 100%;
    /* height: 100%; */
    /* margin: auto; */
  }
  ::v-deep .el-carousel__button {
    width: 10PX;
    border-radius: 10PX;
    height: 10PX;
  }
  ::v-deep .el-carousel__indicator.is-active button {
    background-color: #3879eb;
  }
</style>
